import React, { useEffect, useState } from "react"
import { ScrollView, Text, View, StyleSheet, Pressable, } from "react-native";
import { store } from "../../../store/store";
import AppStyles from "../../../AppStyles";
import AppTheme from "../../../AppTheme";
import { updateQuestionRenderState as updateQuestionRenderReduxState, updateReduxCurrentAnswer } from "../../services/redux/commonRedux";
import { getConsultationAnsValue } from "../../services/econsult/EConsultUtils";
import Checkbox from 'expo-checkbox';
import TextStyle from "../../../TextStyle";
export default function MultipleChoiceFunc() {

    const [data, updateData] = useState({
        ansData: {},
        questionData: {},
        render: false
    })

    const [selectedOption, updateSelectedOption] = useState({
        selectedIndexList: [],
        selectedParamsList: [],
        exclusiveIndex: -1
    })

    function onOptionSelected(index, option) {
        var questionData = data.questionData, exclusiveIndex = -1, isOptionAlreadySelected = false,
            indexList: any = selectedOption.selectedIndexList, paramsList: any = selectedOption.selectedParamsList;
        for (var i = 0; i < indexList.length; i++) {
            if (indexList[i] == index) {
                indexList.splice(i, 1);
                paramsList.splice(i, 1);
                isOptionAlreadySelected = true;
                updateSelectedOption({
                    selectedIndexList: indexList,
                    selectedParamsList: paramsList,
                    exclusiveIndex: -1
                });
            }
        }
        if (indexList.includes(selectedOption.exclusiveIndex)) {
            indexList.splice(indexList.indexOf(selectedOption.exclusiveIndex), 1);
            paramsList.splice(indexList.indexOf(selectedOption.exclusiveIndex), 1);
        }
        if (!isOptionAlreadySelected) {
            if (option.exclusive) {
                indexList.splice(0, indexList.length);
                paramsList.splice(0, paramsList.length);
                exclusiveIndex = index
            }
            indexList.push(index);
            paramsList.push(option['value']);
            updateSelectedOption({
                selectedIndexList: indexList,
                selectedParamsList: paramsList,
                exclusiveIndex: exclusiveIndex,
            });
        };
        const id = questionData['qid'];
        const rskey = questionData['rskey'];
        const ansVal = paramsList;
        const curretAns = {
            [id]: {
                id: id,
                [rskey]: ansVal,
                textInput: {}
            },
        };
        updateReduxCurrentAnswer(curretAns);
        // updateReduxCurrentAnswer({
        //     valueData: curretAns
        // });
    }

    function checkOptionSelected(index) {
        var indexList: any = selectedOption.selectedIndexList;
        return indexList.includes(index);
    }

    function updatePreviousIndexList(qData, ansData) {
        var indexList: any = [], paramsList: any = [],
            exclusiveIndex = -1;
        if (Object.keys(qData).length > 0 && Object.keys(ansData).length > 0) {
            getConsultationAnsValue(qData, ansData).forEach((answer) => {
                qData.options.forEach((option, index) => {
                    if (option.value == answer) {
                        indexList.push(index);
                        paramsList.push(qData.options[index]['value']);
                        if (qData.options[index]['exclusive']) exclusiveIndex = index;
                    }
                })
            });
        }
        updateSelectedOption({
            selectedIndexList: indexList,
            selectedParamsList: paramsList,
            exclusiveIndex: exclusiveIndex
        });
    }

    useEffect(() => {
        const reduxState = store.getState();
        if (reduxState.renderQuestionElement) {
            updateQuestionRenderReduxState(false);
            if (reduxState.currentConsultationQuestion &&
                reduxState.currentConsultationAnswer) {
                const ansData = reduxState.currentConsultationAnswer;
                const qData = reduxState.currentConsultationQuestion;
                // console.log('question and answer data in MCTXT', qData, ansData);
                updatePreviousIndexList(qData, ansData);
                updateData({
                    ansData: ansData,
                    questionData: qData,
                    render: true
                });
            }
        }
    })

    return <ScrollView style={{ marginBottom: 60 }}>
        {
            data.render ? <View style={{ marginHorizontal: 16 }}>

                <Text style={AppStyles.questionText}>
                    {data.questionData['qstr']}
                </Text>

                {
                    data.questionData['options'].map((option, index) =>
                        <Pressable key={index}
                            onPress={() => { onOptionSelected(index, option) }}
                            style={[AppStyles.flexRowStart]}>
                            <Checkbox
                                value={checkOptionSelected(index)}
                                // error in value={checkOptionSelected(index, option.value)}
                                // onValueChange={() => onOptionSelected(index, option, data.questionData)}
                                style={styles.checkbox}
                                color={checkOptionSelected(index) ? AppTheme.color.primary : undefined} />

                            <Text style={TextStyle.text14}>
                                {option['dispStr']}</Text>

                        </Pressable>
                    )
                }

            </View> : <View />
        }
    </ScrollView>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    checkboxContainer: {
        // flexDirection: "row",
        marginBottom: 20,
    },
    checkbox: {
        // alignSelf: "center",
        margin: 10,
        backgroundColor: AppTheme.color.primary,
        height: 15,
        width: 15
    },
    label: {
        margin: 8,
    },
});
